if(typeof require !== 'undefined'){
    var autocomplete = require ('autocompleter')
}


$(function(){
    $('input.cms-autocomplete').each(function(index, input){
        var method = $(input).data('method');
        var instance = new autocomplete({
            input: input,
            fetch: function(text, update) {
                $.getJSON(method, {query: text}, function( data, status, xhr ) {
                    data = data.map(function (value){
                        return {label: value}
                    })
                    update(data)
                });

            },
            onSelect: function(item) {
                input.value = item.label;
                if($(input).data('autosubmit') == true)
                {
                    $(input).closest('form').submit();
                }
            },
            disableAutoSelect: true,
            debounceWaitMs: 300
        })
    });
});